import React from "react";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import "./About.css";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

export const About = () => {
  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };
  return (
    <div className="New-Dashboard" style={sectionStyle}>
      <div className="About-Page">
        <TopNavBar />
        <div className="TopSearchBar">
          <TopSearchBar />
        </div>
        {/* <Header /> */}
        {/* <SeachSection /> */}
        {/* <Catalogue />
      <Brand /> */}
        <section style={{ width: "100%" }}>
          <section class="orders contact-info">
            <div class="container">
              <h3 class="text-uppercase mb-md-4"> About us </h3>
              <div class="row about">
                <div class="col-lg-12">
                  <p className="About-p">
                    Auto Spare Parts is one of the leading importers, exporters
                    and distributors of original and after-market auto body
                    parts. We specialize in body spare parts of all major German
                    brands such as Mercedes Benz, BMW, Range Rover, Audi,
                    Volkswagen and Porsche.
                  </p>

                  <p className="About-p">
                    SSG ASIA is a global wholesale and retail top brand supplier
                    of genuine and quality replacement AUTO SPARE PARTS and
                    accessories from the Dubai, United Arab Emirates (UAE) and
                    the Arab Gulf states to any country in the world. We are
                    constantly improving our transportation logistics. At your
                    request, we can supply auto parts from the UAE to any city
                    in the world. SSG ASIA is a team of top professionals with
                    over 10-years’ experience in the field. The
                    customer-oriented online catalogue of our online store
                    offers more than 26 million unique "OEM" items that cover
                    all of today's major automotive manufacturers.
                  </p>
                  <img
                    src="images/about.png"
                    className="About-img"
                    alt="About"
                  />
                  <h6>Why choose ASIA PART SOUQ Spares?</h6>
                  <p className="About-p">
                    Auto Spare Parts is one of the leading importers, exporters
                    and distributors of original and after-market auto body
                    parts. We specialize in body spare parts of all major German
                    brands such as Mercedes Benz, BMW, Range Rover, Audi,
                    Volkswagen and Porsche.
                  </p>
                  <ul>
                    <li>Competitive and reasonable prices</li>
                    <li>100% Genuine OEM/OES/Aftermarket products</li>
                    <li>Last-mile logistics solutions</li>
                    <li>Quality tested products along with brand awareness</li>
                    <li>
                      Trustworthiness on our each product purchase with 24×7
                      customer support
                    </li>
                    <li>Pan-India sourcing.</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* <Footer /> */}
      </div>
    </div>
  );
};
